







































import AppSidebar from "./components/partials/AppSidebar.vue";
import consts from "./consts";
import { sortAlphabetical, parseAuthToken } from "./utils";
import { getURLParam, loginSocial } from "./auth";
import axios from "axios";
import Chart from "chart.js";
import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import { Team, User, UserSelf, UserStat, LearnerTeam } from "./types";
import { Getter, Action } from "vuex-class";
import { teamCode } from "@/api";

@Component({
  components: { AppSidebar }
})
export default class MainView extends Vue {
  @Getter private JWT?: string;
  @Getter private UID?: string;
  @Getter private teams?: Team[];
  @Getter private currentTeamID?: number;
  @Getter private currentTeam?: Team;
  @Getter private currentTeamUsers?: User[];
  @Getter private currentTeamStats?: UserStat[];
  @Getter private displayError?: any;
  @Getter private teamByID!: (id: number) => Team;
  @Getter private userByID!: (uid: string) => User;

  @Action private setJWT?: any;
  @Action private setUID?: any;
  @Action private setCurrentTeam?: any;
  @Action private setDisplayError: any;
  @Action private fetchTeams!: () => any;
  @Action private fetchCurrentTeamStats!: () => any;
  @Action private fetchTeamUsers!: (teamID: number) => any;
  @Action private fetchLearnerTeams!: (onSuccess:Function, onError:Function) => any;

  private userEmail?: string;

  private created() {
    this.setCurrentTeam(null);
    this.checkAuth();
    this.fetchTeams();
    this.setChartsJS();
  }

  @Watch("displayError")
  private onDisplayError() {
    if (this.displayError && this.displayError !== null) {
      this.$bvToast.toast(this.displayError, {
        title: "Error",
        variant: "danger",
        solid: true
      });
      this.setDisplayError(null);
    }
  }

  private setTeam() {
    let paramTeamID = this.$route.params.teamID;
    console.log("router paramTeamID:" + paramTeamID);

    if (this.teams && this.teams.length < 1) {
      console.error(
        "Somehow user was able to move forward without having any teams"
      );
      return;
    }

    if (!paramTeamID) {
      console.log("No team in param:");

      let team = this.teams![0];
      if (this.currentTeam == null || team.ID !== this.currentTeamID) {
        this.setCurrentTeam(team);
        this.routeToFirstTeam();
      }
      return;
    }
    let team = this.teamByID(Number(paramTeamID));
    this.setCurrentTeam(team);
  }
  /**
   * Update JWT and UID into the store
   * if required. JWT and UID is already set in
   * login.vue if that flow is used.
   */
  private setAuthVars(jwt: string) {
    this.setJWT(jwt);
    let authParams = parseAuthToken(jwt);
    this.setUID(authParams.uid);
  }

  private checkAuth() {
    let isCookie = this.$cookies.isKey("ORAI_AUTH");
    console.log("isCookie:"+isCookie)
    let JWT = this.$cookies.get("ORAI_AUTH");
    let SSOToken = this.$route.query.token;
    // getURLParam("token", window.location);
    console.log(JWT)
    if ((this.$route.name === 'reviewedSession' || this.$route.name === 'feedback') && SSOToken) {
      return;
    }

    if (SSOToken) {
      SSOToken = SSOToken as string;
      // Looks like some invite token hack
      // todo: look into this and refactor possibly with store
      loginSocial(
        SSOToken,
        (jwt: string, user: UserSelf) => {
          if (localStorage.invitetoken) {
            const temp = localStorage.invitetoken;
            localStorage.removeItem("invitetoken");
            this.$router.push({
              name: "invite",
              params: { inviteID: temp }
            });
            return;
          }
          this.setAuthVars(jwt);
          this.fetchTeams();
        },
        (err: any) => {
          console.error(err);
        }
      );
    } else if (JWT) {
      this.setAuthVars(JWT);
    } else {
      // Not logged in, redirect to login
      console.log("heher");
      this.$router.push({
        name: "login",
        params: { redirect: window.location.pathname }
      });
      return;
    }
  }

  private isValidRoute(): boolean {
    return true;
  }

  private setChartsJS() {
    let chart: any = Chart!;
    // if (Chart) {
    chart.defaults.global.legend.display = false;
    chart.defaults.global.elements.point.radius = 2;
    chart.defaults.global.layout.padding.left = 0;
    chart.defaults.global.layout.padding.right = 0;
    chart.defaults.global.layout.padding.top = 0;
    chart.defaults.global.layout.padding.bottom = 0;
    chart.defaults.global.stepsize = 1;
    chart.defaults.doughnut.cutoutPercentage = 80;
    chart.defaults.doughnut.animation.animationEasing = "easeOutBounce";
    chart.defaults.scale.gridLines.color = "#F2F6F9";
    // }
  }

  private routeToFirstTeam() {
    if (this.teams && this.teams.length > 0) {
      let routeName = this.$route.name;
      let team = this.teams[0];
      this.changeTeam(team.ID);
    }
  }

  private changeTeam(teamID: number) {
    let team = this.teamByID(teamID);
    this.setCurrentTeam(team);
    let routeName = this.$route.name;
    if (routeName === "configureReviewers") {
      this.$router.push({
        name: "configureReviewers",
        params: { teamID: teamID.toString() }
      });
    } else if (routeName === "manageRubric") {
      this.$router.push({
        name: "manageRubric",
        params: { teamID: teamID.toString() }
      });
    } else if (routeName === "review" || team.role === "reviewer") {
      this.$router.push({
        name: "review",
        params: { teamID: teamID.toString() }
      });
    } else {
      this.$router.push({
        name: "team",
        params: { teamID: teamID.toString() }
      });
    }
  }

  @Watch("currentTeam")
  private currentTeamChange() {
    let routeName = this.$route.name;
    if (
      this.currentTeam &&
      routeName !== "review" &&
      this.currentTeam.role !== "reviewer"
    ) {
      this.fetchTeamUsers(this.currentTeam.ID);
      this.fetchCurrentTeamStats();
    }
  }

  @Watch("teams")
  private teamsChange() {
    if (!this.teams || !this.teams.length) {
      this.$router.push({ name: "learner" });
      return;
    }
    this.setTeam();
  }

  private refreshTeamUsersData() {
    console.log("Somebody called refreshTeamUYSersData legacy function");
  }

  private refreshTeamData() {
    console.log("Somebody called refreshTeamData legacy function");
  }

  private refreshTeamsData() {
    console.log("Somebody called refreshTeamsData legacy function");
  }

  //     fetchTeamData() {
  //       axios
  //         .get(
  //           consts.serverURL + 'user/' + this.UID + '/teams/',
  //           { headers: { Authentication: this.JWT } },
  //         )
  //         .then((resp) => {
  //           this.teams = resp.data;

  //           // Check if not a manager
  //           if (!this.teams || !this.teams.length) {
  //             this.$router.push({ name: 'feedback' });
  //             return;
  //           }

  // let routeTeamID = this.$route.params.teamID;
  // let teamMatched = false;

  //           console.log('TEAMS', this.teams, routeTeamID);
  //           if (routeTeamID) {
  //             // Choose team specified in route
  //             // tslint:disable-next-line:forin
  //             for (let i in this.teams) {
  //               let currTeamID = this.teams[i].ID.toString();
  //               teamMatched = currTeamID === routeTeamID;
  //               if (teamMatched) {
  //                 this.changeTeam(routeTeamID, true);
  //                 break;
  //               }
  //             }
  //           }

  //           // Choose first team if no valid team specified in route
  //           if (!teamMatched) {
  //             this.routeToFirstTeam();
  //           }
  //         })
  //         .catch(reason => {
  //           console.log(reason, reason.response);
  //         });
  //     },
  //     refreshTeamUsersData() {
  //       if (this.currentTeamID) {
  //         axios
  //           .get(
  //             consts.serverURL + 'team/' + this.currentTeamID + '/users/',
  //             {
  //               headers: { Authentication: this.JWT },
  //               cancelToken: this.cancelToken.token
  //             },
  //           )
  //           .then((resp) => {
  //             console.log('CURRENT TEAM USERS', resp.data);
  //             let users = resp.data;

  //             // Find current user obj
  //             if (!this.currUser) {
  //               for (let i in users) {
  //                 if (users[i].UID === this.UID) {
  //                   this.currUser = users[i];
  //                   break;
  //                 }
  //               }
  //             }

  //             users.sort(sortAlphabetical);
  //             this.currentTeamUsers = users;
  //           })
  //           .catch(reason => {
  //             console.log(reason, reason.response);
  //           });
  //       }
  //     },
  //     refreshTeamsData(teamToChangeTo) {
  //       axios
  //         .get(
  //           consts.serverURL + 'user/' + this.UID + '/teams/',
  //           { headers: { Authentication: this.JWT } },
  //         )
  //         .then((resp) => {
  //           this.teams = resp.data;

  //           if (teamToChangeTo) {
  //             this.changeTeam(teamToChangeTo, true);
  //           }
  //         });
  //     },
  //     refreshTeamData() {
  //       if (this.currentTeamID) {
  //         axios
  //           .get(
  //             consts.serverURL + 'team/' + this.currentTeamID,
  //             {
  //               headers: { Authentication: this.JWT },
  //             },
  //           )
  //           .then((resp) => {
  //             console.log('CURRENT TEAM', resp.data);
  //             this.currentTeam = resp.data;

  //             axios
  //               .get(
  //                 consts.serverURL + 'enterprise/' + this.currentTeam.EnterpriseID + '/licenses/',
  //                 {
  //                   headers: { Authentication: this.JWT },
  //                 },
  //               )
  //               .then((resp2) => {
  //                 console.log('CURRENT LICENSES', resp2.data);
  //                 if (resp2.data.length) {
  //                   this.currentTeam.license = resp2.data[0];
  //                 }
  //               });
  //           });

  //         // Fetch users
  //         this.refreshTeamUsersData();

  //         axios
  //           .get(
  //             consts.serverURL + 'team/' + this.currentTeamID + '/user_statistics',
  //             { headers: { Authentication: this.JWT } },
  //           )
  //           .then((resp) => {
  //             let userStats = resp.data;
  //             // Sort alphabetically by name
  //             userStats.sort(sortAlphabetical);
  //             this.userStats = userStats;
  //           });
  //       }
  //     },
  //     isValidRoute(teamID, userID) {
  //       if (this.currentTeamID === teamID) {
  //         if (this.currentTeamUsers) {
  //           for (let i in this.currentTeamUsers) {
  //             if (this.currentTeamUsers[i].UID === userID) {
  //               return true;
  //             }
  //           }
  //         }
  //       }
  //       return false;
  //     }
  //   },
  //   watch: {
  //     $route(newVal, oldVal) {
  //       // Reset scroll
  //       window.scrollTo(0, 0);

  //       let routeTeamID = newVal.params.teamID;
  //       console.log('ROUTE CHANGE TEAM', newVal, oldVal, this.teams, this.currentTeamID, routeTeamID);
  //       if (routeTeamID !== this.currentTeamID) {
  //         // tslint:disable-next-line:forin
  //         for (let i in this.teams) {
  //           let currTeamID = this.teams[i].ID.toString();
  //           if (currTeamID === routeTeamID) {
  //             this.changeTeam(routeTeamID);
  //           }
  //           break;
  //         }
  //       }

  //       // Handle home redirect
  //       if (newVal.name === 'home') {
  //         if (this.currentTeamID) {
  //           this.$router.push({ name: 'team', params: { teamID: this.currentTeamID } });
  //         } else {
  //           this.routeToFirstTeam();
  //         }
  //       }
  //     },
  //   }
  // }
}
